import { createAxios } from './axios-create';

export const axiosWebClient = () => createAxios({});
